
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { isPositiveInteger } from "@common/src/utils/verify";
import NoticeChannel from "@common/src/components/scope/notice-channel/index.vue";
import t from "@common/src/i18n/t";
const marketing = namespace("marketing");
@Component({
  components: {
    NoticeChannel
  }
})
export default class UpkeepAlertSet extends Vue {
  @marketing.Action queryRemindSetting;
  @marketing.Action createRemindSetting;
  selectchannel = [];
  returnForm = {
    noLimit: undefined,
    generationRule: "1",
    advanceDate: undefined,
    advanceDayList: [],
    radioNumber: undefined,
    enableStatus: 2,
    remindWay: "1",
    pushChannelList: [],
    notifyMethods: [],
    wechatChecked: false,
    messageChecked: false,
    expireMaintainDate: undefined,
    expireMaintainDayList: []
  };
  multipleValueArr = (rule, value, callback) => {
    if (!value) {
      callback(new Error(t("v210831.please-select-a-limit")));
    } else {
      callback();
    }
  };
  upkeepRule(value, callback) {
    if (isPositiveInteger(value)) {
      callback();
    } else {
      callback(new Error(t("v210831.please-enter-a-not-0")));
    }
  }
  channel(value, callback) {
    if (this.returnForm.remindWay === "1" && !this.returnForm.notifyMethods.length) {
      callback(new Error(t("v210831.please-select-a-path")));
    } else {
      callback();
    }
  }
  wechatCheckedValueArr = (rule, value, callback) => {
    this.channel(value, callback);
  };
  expireMaintainDateRule = (rule, value, callback) => {
    if (!value) {
      callback();
    } else {
      this.upkeepRule(value, callback);
    }
  };
  returnFormRule = {
    generationRule: [{ validator: this.multipleValueArr, trigger: "blur" }],
    remindWay: [{ required: true, message: t("v210831.please-select-a-type"), trigger: "blur" }],
    wechatChecked: [{ validator: this.wechatCheckedValueArr, trigger: "blur" }],
    messageChecked: [{ validator: this.wechatCheckedValueArr, trigger: "blur" }],
    notifyMethods: [{ required: true, validator: this.wechatCheckedValueArr, trigger: "blur" }],
    enableStatus: [{ required: true, message: t("setting.select-whether-enable"), trigger: "blur" }],
    expireMaintainDate: [{ validator: this.expireMaintainDateRule, trigger: ["blur", "change"] }]
  };
  created() {
    this.init();
  }

  init() {
    this.queryRemindSetting().then(res => {
      if (res.data) {
        this.selectchannel = res.data.notifyMethods;
        this.returnForm.notifyMethods = res.data.notifyMethods;
        this.returnForm.remindWay = res.data.remindWay;
        this.returnForm.enableStatus = res.data.enableStatus;
      }
      try {
        this.returnForm.advanceDayList =
          res.data && res.data.advanceDayList.length > 0 ? res.data.advanceDayList : [""];
        this.returnForm.expireMaintainDayList =
          res.data && res.data.expireMaintainDayList.length > 0 ? res.data.expireMaintainDayList : [""];
      } catch (e) {
        //
      }
    });
  }
  arrayItemIsRepeat(arr) {
    const hash = {};
    for (let i in arr) {
      if (hash[arr[i]]) {
        return true;
      } else if (arr[i]) {
        // 不对空值进行重复确认
        hash[arr[i]] = true;
      }
    }
    return false;
  }
  submitForm(returnForm) {
    if (
      this.returnForm.advanceDayList.some(item => {
        return !item;
      })
    ) {
      this.$message.error(t("v213.please-complete-the-reminder-days-before-service-date"));
      return false;
    }
    if (this.arrayItemIsRepeat(this.returnForm.advanceDayList)) {
      this.$message.error(t("v213.the-reminder-days-before-the-next-set-repeatedly"));
      return false;
    }
    if (this.arrayItemIsRepeat(this.returnForm.expireMaintainDayList)) {
      this.$message.error(t("v213.the-reminder-days-after-the-next-set-repeatedly"));
      return false;
    }
    const allDayList = [].concat(this.returnForm.advanceDayList, this.returnForm.expireMaintainDayList);
    if (
      allDayList.some(item => {
        return item && !isPositiveInteger(item);
      })
    ) {
      this.$message.error(t("v213.reminder-days-are-an-integer-greater-than-0"));
      return false;
    }
    let refForm = this.$refs[returnForm] as any;
    refForm.validate(valid => {
      if (valid) {
        let data = {
          ...this.returnForm
        };
        this.createRemindSetting(data).then(() => {
          this.$message.success(t("v210831.maintenance-reminder-rule"));
          this.init();
        });
      } else {
        console.log("error submit!!");
        return false;
      }
    });
  }
  changeRevisitType() {
    this.selectchannel = [];
    this.returnForm.notifyMethods = [];
  }
  handleAddAdvanceDay() {
    this.returnForm.advanceDayList.push(undefined);
  }
  handleDeleteAdvanceDay(index) {
    this.returnForm.advanceDayList.splice(index, 1);
  }
  handleAddexpireMaintainDay() {
    this.returnForm.expireMaintainDayList.push(undefined);
  }
  handleDeleteExpireMaintainDay(index) {
    this.returnForm.expireMaintainDayList.splice(index, 1);
  }
}
